import Vue from 'vue';

const state = () => {
    uploadingFiles: []
}

const getters = {
    getFileUploadings: state => state.uploadingFiles
}

const mutations = {
    setFileUploading(state, uploadingFile){
        if(uploadingFile.relationId){
            let item = {
                index: uploadingFile.index,
                relationId: uploadingFile.relationId,
                originName: uploadingFile.originName,
                storedName: uploadingFile.storedName,
                type: uploadingFile.type
            }
            if(state.uploadingFiles)
                state.uploadingFiles.push(item);
            else
                state.uploadingFiles = [item];

            console.log(state)
        }
    },
    removeFileUploaded(state, itemIndex){
        Vue.delete(state.uploadingFiles, itemIndex)
    }
}

export default { namespaced: true, state, getters, mutations };